'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Label;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Label(_ref) {
  var _ref$schema = _ref.schema,
      schema = _ref$schema === undefined ? {} : _ref$schema,
      _ref$label = _ref.label,
      label = _ref$label === undefined ? schema.label : _ref$label;

  return label ? _react2.default.createElement(
    'label',
    null,
    label
  ) : _react2.default.createElement('noscript', null);
} /**
   * @copyright 2015, Prometheus Research, LLC
   */
